import React from "react";

import Testimonials from "../../../subscreens/customer/home/testimonials/Testimonials";
import Footer from "../../../components/general/footer/Footer";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import PageHero from "../../../components/general/pageHero/PageHero";
import HeroStats from "../../../subscreens/customer/about/HeroStats";
import ProcessSection from "../../../subscreens/customer/about/ProcessSection";
// import BrandsBanner from "../../../subscreens/customer/about/BrandsBanner";

export default function AboutUs() {
  return (
    <>
      <MyNavbar />
      <PageHero title="About Us" breadcrumb="about" />

      <ProcessSection />
      {/* <HeroStats /> */}
      <Testimonials />
      <Footer />
    </>
  );
}
